import './Member.css';
import { useMemo, useState } from 'react';
import 'react-tooltip/dist/react-tooltip.css'
import { useEffect } from 'react';
import { Tooltip as ReactTooltip } from "react-tooltip";
import { toast } from 'react-toastify';
import httpClient from '../../HTTPService';
import moment from 'moment';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import DynamicTooltip from './CustomTooltip';
import TooltipManager from './CustomTooltip';
const Member = () => {
    const params = useParams();
    let { filters } = params
    const [offsetValue, setoffsetValue] = useState(0);
    const [memberlist, setmemberlist] = useState([]);
    const [originalMemberList, setOriginalMemberList] = useState([])
    const navigate = useNavigate();
    const [searchtext, setsearchtext] = useState('')
    const [totalCount, setTotalCount] = useState(0)
    const [currentPage, setCurrentPage] = useState(1);
    const [getLimit, setLimit] = useState(10);
    const items = Array.from({ length: totalCount }, (_, index) => `Item ${index + 1}`);
    const itemsPerPage = 10;
    const totalPages = Math.ceil(items.length / getLimit);
    const startPage = Math.max(1, currentPage - Math.floor(5 / 2));
    const endPage = Math.min(totalPages, currentPage + Math.floor(5 / 2));
    const [filter, setfilter] = useState(filters == 'paid' ? 4 : null)
    let location = useLocation()
    const [setChange, setLimitChange] = useState(false)
    const handlePageChange = (page) => {
        setCurrentPage(page);
        // location  = undefined
    };

    const [filterblock, setfilterblock] = useState(null)

    const startIndex = (currentPage - 1) * getLimit;
    const currentItems = items.slice(startIndex, startIndex + getLimit);

    //pagination
    const Pagination = ({ currentPage, totalPages, onPageChange }) => {
        const pages = [];
        for (let i = 1; i <= totalPages; i++) {
            pages.push(i);
        }
        console.log(currentPage, 'current pages...')
        return (
            <div className="pagination">
                {currentPage > 1 && (
                    <button className="pagination-btn" onClick={() => onPageChange(currentPage - 1)}>
                        <i className="fa fa-chevron-left" aria-hidden="true"></i>
                    </button>
                )}
                {startPage > 1 && (
                    <button className="pagination-btn" onClick={() => onPageChange(1)}>
                        1
                    </button>
                )}
                {startPage > 2 && <span className="pagination-ellipsis">...</span>}
                {pages.slice(startPage - 1, endPage).map(page => (
                    <button
                        key={page}
                        className={`pagination-btn ${page === currentPage ? 'active' : ''}`}
                        onClick={() => onPageChange(page)}
                    >
                        {page}
                    </button>
                ))}
                {endPage < totalPages - 1 && <span className="pagination-ellipsis">...</span>}
                {endPage < totalPages && (
                    <button className="pagination-btn" onClick={() => onPageChange(totalPages)}>
                        {totalPages}
                    </button>
                )}
                {currentPage < totalPages && (
                    <button className="pagination-btn" onClick={() => onPageChange(currentPage + 1)}>
                        <i className="fa fa-chevron-right" aria-hidden="true"></i>
                    </button>
                )}
            </div>
        );
    };

    useEffect(() => {

        console.log(filters, location?.state, 'locaton data....//?')
        if (location?.state?.backpagi == undefined) {
            if (filters == 'paid') {
                console.log('paiddddd')
                getMembers3(searchtext, currentPage, getLimit)

            } else {
                console.log('normal////')
                getMembers(searchtext, currentPage, getLimit)

            }
            // getMembers();
        } else if (location?.state?.backpagi != undefined) {
            //    console.log('fkjsdfjskfjskfjsklfjskf')
            setCurrentPage(location?.state?.backpagi?.pageCurrent)
            setLimit(location?.state?.backpagi?.limit)
            if (filters == 'paid') {
                console.log('paiddddd')
                getMembers3(searchtext, location?.state?.backpagi?.pageCurrent, location?.state?.backpagi?.limit)

            } else {
                console.log('normal////')
                getMembers(searchtext, location?.state?.backpagi?.pageCurrent, location?.state?.backpagi?.limit)

            }
        }

    }, [currentPage, getLimit, filter, filters]);
    const editItem = (e) => {
        // console.log(e);
        let paginationState = {
            pageCurrent: currentPage,
            limit: getLimit,

        }
        navigate(`/memberprofile-details?id=${e?.id}`, {
            state: {
                paginationState
            }
        });
        //  localStorage.setItem('editSubData',editSub)
    }
    const viewIncome = (e) => {
        let paginationState = {
            pageCurrent: currentPage,
            limit: getLimit,

        }
        navigate(`/memberincome?id=${e?.id}/:income`,
            {
                state: {
                    paginationState
                }
            }

        );
        //  localStorage.setItem('editSubData',editSub)
    }
    const viewTeam = (e) => {
        console.log(e);
        let paginationState = {
            pageCurrent: currentPage,
            limit: getLimit,

        }
        // const editSub = JSON.stringify(e)
        navigate(`/member-teamdetails?id=${e?.id}`,

            {
                state: {
                    paginationState
                }
            }
        );
        //  localStorage.setItem('editSubData',editSub)
    }
    const searchtxt = () => {
        getMembers(searchtext, 1, getLimit);
    }

    // view tooltip
    function setTooltipMessage(message) {
        const tooltipBox = document.getElementById('tooltipBox');
        tooltipBox.textContent = message;
    }
    const getMembers = async (search_name, pagecount, limit) => {
        try {
            const result = await httpClient.post('/admin/member-list', {
                search_name,
                offset: pagecount, limit: limit,
                // search_status:filter,
                search_membership_type: filters == 'blocked' ? 0 : filters == 'unpaid' ? 3 : filters == 'paid' ? 4 : filter,
                // search_is_blocked:filterblock
            }, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            if (result.status === 200) {
                // location?.state = ''
                // console.log(result.data.data, 'data..')
                // location.state = null
                setTotalCount(result?.data.total_count)
                console.log(result?.data?.data, 'member sli sere')
                setmemberlist(result?.data?.data)
                setChange(false)
            }

        } catch (error) {
            //   toast.error(error.message)
        }
    }
    const getMembers3 = async (search_name, pagecount, limit) => {
        try {
            const result = await httpClient.post('/admin/member-list', {
                search_name,
                offset: pagecount, limit: limit,
                // search_status:filter,
                search_membership_type: filter,
                // search_is_blocked:filterblock
            }, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            if (result.status === 200) {
                // location?.state = ''
                // console.log(result.data.data, 'data..')
                // location.state = null
                setTotalCount(result?.data.total_count)
                console.log(result?.data?.data, 'member sli sere')
                setmemberlist(result?.data?.data)
                setChange(false)
            }

        } catch (error) {
            //   toast.error(error.message)
        }
    }

    // filterd data
    useMemo(() => {
        console.log(filter, 'filterd...')

        // if (filter != 3) {
        //     let _filterdata = [...originalMemberList].filter(_fitem => _fitem.active == filter)
        //     console.log(_filterdata, filter, 'filted data..')
        //     setmemberlist(_filterdata)
        // } else if (filter == 3) {
        // //     console.log('set orginal')
        //     setmemberlist(originalMemberList)
        // }
        // getMembers()

        return () => { }

    }, [])


    // debounce function to limit the number of API calss
    function debounce(func, delay) {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func(...args), delay);
        };
    }
    // search handler function
    const searchHandler = debounce((query) => {
         setsearchtext(query);
        getMembers(query, 1, getLimit);
    }, 2000)
    return (
        <div className="member">

            <div className=''>

                <div className="search-box" >
                    {
                        filters == 'paid' && (
                            <div class="searchtct " style={{
                                paddingRight: 20
                            }}>

                                <i class="fa fa-filter" aria-hidden="true"></i>
                                <select
                                    value={filter}
                                    // className='ml-3'
                                    // disabled={chooseFldType ===     '' ? true : false}
                                    onChange={(val) => {
                                        // if (val.target.value == 1 || val.target.value == 2 || val.target.value == null) {
                                        navigate('/member/paid')
                                        setfilter(val.target.value)
                                        // } else {
                                        //     setfilter(val.target.value)

                                        // }

                                    }}
                                //   className={(isrequired && labelvalue === null) ? 'required' :'' }
                                >
                                    <option value={4} >All Purchase</option>
                                    <option value={1}>Profile Added</option>
                                    <option value={2}>Service Used</option>
                                    <option value={0}>Block</option>

                                </select>

                            </div>
                        )
                    }

                    {
                        filters == 'all' && (
                            <div class="searchtct " style={{
                                paddingRight: 20
                            }}>

                                <i class="fa fa-filter" aria-hidden="true"></i>
                                <select
                                    value={filter}
                                    // className='ml-3'
                                    // disabled={chooseFldType ===     '' ? true : false}
                                    onChange={(val) => {
                                        if (val.target.value == null) {
                                            navigate('/member/all')
                                            setfilter(val.target.value)
                                        } else {
                                            setfilter(val.target.value)

                                        }

                                    }}
                                //   className={(isrequired && labelvalue === null) ? 'required' :'' }
                                >
                                    <option value={null} >All Member</option>
                                    <option value={4}>Paid </option>
                                    <option value={3}>Unpaid </option>
                                    <option value={0}>Block</option>
                                    <option value={5}>Deleted </option>


                                </select>

                            </div>
                        )
                    }
                    <div class="searchtct">

                        <i class="fa fa-search" aria-hidden="true"></i>
                        <input type="text" name="text" placeholder="Search..."
                            onChange={(val) => searchHandler(val.target.value ,currentPage,getLimit)}

                        />
                        {/* <button type='button' className='searchBtn' onClick={searchtxt} >Search</button> */}


                    </div>

                </div>
            </div>

            <h4>
                {
                    (filters == 'blocked' || filter == 0) ? `Total Blocked Member: ${totalCount}` :
                        (filters == 'unpaid' || filter == 3) ? `Total Unpaid Member: ${totalCount}` :
                            (filters == 'paid' || filter == 4) ? `Total paid Member: ${totalCount}` :
                                `Total  Member: ${totalCount}`
                }
                {/* {
                location?.state?.unpaid != undefined ?  :
                    location?.state?.paid != undefined ? `Total Paid Member: ${totalCount}` : `Total Member: ${totalCount}`
            }
             */}
            </h4>
            <div class="row">
                <div class="col-md-12">
                    <div class="table-responsive">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>SL NO</th>
                                    <th> Member ID</th>
                                    <th>Name</th>
                                    {/* <th>Validity</th>
                <th >Description</th> */}
                                    {/* <th>Discount</th>
                <th>Price</th> */}
                                    <th>Refered ID</th>
                                    <th>Mobile</th>
                                    <th>Address</th>
                                    <th>Joing Date</th>
                                    <th>Member Status</th>
                                    <th>Position</th>
                                    <th>Income</th>
                                    <th>Profile</th>
                                    <th>Team</th>
                                </tr>
                            </thead>
                            <tbody>

                                {
                                    memberlist?.map((item, index) => {
                                        const serialNumber = (currentPage - 1) * getLimit + index + 1;

                                        return (
                                            <>
                                                <tr >
                                                    <td
                                                        style={{
                                                            backgroundColor: item?.phone == null ? 'gray' : 'transparent',
                                                            color: item?.phone == null ? 'white' : 'black'
                                                        }}
                                                    >{serialNumber}</td>
                                                    <td style={{
                                                        backgroundColor: item?.phone == null ? 'gray' : 'transparent',
                                                        color: item?.phone == null ? 'white' : 'black'
                                                    }}>{item?.member_code}</td>
                                                    <td style={{
                                                        backgroundColor: item?.phone == null ? 'gray' : 'transparent',
                                                        color: item?.phone == null ? 'white' : 'black'
                                                    }}>{item?.name}</td>
                                                    <td style={{
                                                        backgroundColor: item?.phone == null ? 'gray' : 'transparent',
                                                        color: item?.phone == null ? 'white' : 'black'
                                                    }}>
                                                        {/* < TooltipManager
                                                            selector=".reffered-td"
                                                            data={memberlist}
                                                            index={index}
                                                            getMessage={(el) => `${item?.referred_by != [] ? memberlist[index]?.referred_by?.name : ''}`}
                                                        /> */}
                                                        <ReactTooltip
                                                            id={item?.member_code}
                                                            place="bottom"
                                                            render={() => (
                                                                <div style={{
                                                                    padding: 0,
                                                                    margin: 0,
                                                                }}>
                                                                    <p style={{
                                                                        padding: 0,
                                                                        margin: 0
                                                                    }}>
                                                                        {item?.referred_by?.name || ''}
                                                                    </p>
                                                                    {item?.status === 0 && (
                                                                        <p style={{
                                                                            color: 'red', padding: 0, margin: 0, textAlign: 'center'
                                                                        }}>Block</p>
                                                                    )}
                                                                </div>
                                                            )}
                                                        />
                                                        {/* <ReactTooltip
                                                            id={item?.phone}
                                                            place='bottom'
                                                            content={item?.referred_by != [] ? item?.referred_by?.name : ''}

                                                        />
                                                        <p data-tooltip-id={item?.phone}></p> */}
                                                        <div data-tooltip-id={item?.member_code} >
                                                            {item?.referred_by?.user_referral_code || ''}
                                                        </div>
                                                    </td>
                                                    {/* <td>{item?.referred_by != [] ? item?.referred_by?.user_referral_code : ''}</td> */}
                                                    <td style={{
                                                        backgroundColor: item?.phone == null ? 'gray' : 'transparent',
                                                        color: item?.phone == null ? 'white' : 'black'
                                                    }}>{item?.phone}</td>
                                                    <td className='address-td text_view' style={{
                                                        backgroundColor: item?.phone == null ? 'gray' : 'transparent',
                                                        color: item?.phone == null ? 'white' : 'black'
                                                    }}>
                                                        {item?.address !== null ? item?.address : '--'}
                                                    </td>
                                                    <td className='joing-date' style={{
                                                        backgroundColor: item?.phone == null ? 'gray' : 'transparent',
                                                        color: item?.phone == null ? 'white' : 'black'
                                                    }}>
                                                        <p style={{
                                                            padding: 0,
                                                            margin: 0
                                                        }}>
                                                            {moment(item?.joing_date).format('DD-MM-YYYY')}

                                                        </p>

                                                    </td>
                                                    <td style={{
                                                        backgroundColor: item?.phone == null ? 'gray' : 'transparent',
                                                        color: item?.phone == null ? 'white' : 'black'
                                                    }}>
                                                        <span className={item?.active == 1 ? "active" : "inactive"}>{item?.active == 1 ? "Active" : "Inactive"}</span>

                                                        {
                                                            item?.active_date && (<p className='member-expiridata'
                                                                style={{
                                                                    padding: 0,
                                                                    margin: 0,
                                                                }}
                                                            >{

                                                                    moment(item?.active_date).format('DD-MM-YYYY')

                                                                }</p>)
                                                        }
                                                        {
                                                            item?.status == 0 && (
                                                                <p style={{
                                                                    color: 'red',
                                                                    padding: 0,
                                                                    margin: 0,
                                                                    textAlign: 'center',
                                                                    marginRight: '20px'
                                                                }}>Block</p>

                                                            )
                                                        }

                                                    </td>
                                                    <td className='position_td' style={{
                                                        backgroundColor: item?.phone == null ? 'gray' : 'transparent',
                                                        color: item?.phone == null ? 'white' : 'black'
                                                    }}>
                                                        {/* <div style={{
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            backgroundColor:'red'


                                                        }}> */}



                                                        <p>
                                                            {item?.added_profile_count != null ? `Profile Added--${item?.added_profile_count}` : "--"}
                                                        </p>
                                                        <p> {item?.used_profile_count != null ? `Service Used--${item?.used_profile_count}` : "--"}

                                                        </p>





                                                        {/* </div> */}
                                                    </td>
                                                    <td style={{
                                                        backgroundColor: item?.phone == null ? 'gray' : 'transparent',
                                                        color: item?.phone == null ? 'white' : 'black'
                                                    }}>
                                                        <div className='table-column'>
                                                            <i
                                                                style={{
                                                                    // width:60,
                                                                    fontSize: 20
                                                                    // height:60
                                                                }}

                                                                onClick={() => viewIncome(item)}
                                                                class="fa fa-money team-incom" aria-hidden="true"></i>
                                                        </div>


                                                    </td>
                                                    <td style={{
                                                        backgroundColor: item?.phone == null ? 'gray' : 'transparent',
                                                        color: item?.phone == null ? 'white' : 'black'
                                                    }}>
                                                        <div className='table-column'>
                                                            <i
                                                                style={{
                                                                    fontSize: 20
                                                                }}
                                                                onClick={() => editItem(item)}
                                                                class="fa fa-user team-incom" aria-hidden="true"></i>
                                                        </div>
                                                    </td>
                                                    <td style={{
                                                        backgroundColor: item?.phone == null ? 'gray' : 'transparent',
                                                        color: item?.phone == null ? 'white' : 'black'
                                                    }}>
                                                        <div className='table-column'>
                                                            <i
                                                                style={{
                                                                    fontSize: 20
                                                                }}
                                                                onClick={() => viewTeam(item)}

                                                                class="fa fa-group team-incom" aria-hidden="true"></i>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </>
                                        )
                                    })
                                }

                            </tbody>

                        </table>
                        <div className='nodata-found-div'>
                            {
                                memberlist?.length == 0 ?
                                    <p>No Data Found</p>
                                    //  <img 
                                    //  className='table-image'
                                    //  src={require('../../assets/OIP.png')}/>
                                    : null
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div class="tablepgntn">
                <p>Show <select value={getLimit} onChange={(val) => {
                    setLimit(val.target.value)
                    setCurrentPage(1)
                    // setLimitChange(true)
                }}>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={30}>30</option>
                    <option value={40}>40</option>
                    <option value={50}>50</option>
                </select> Entries</p>
                <ul>

                </ul>
                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                />

            </div>

        </div>
    )
}
const boxStyle = {
    width: '200px',
    height: '60px',
    background: '#bbb',
    margin: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '6px',
    cursor: 'pointer'
}
export default Member;